var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50522 14.5034L4.69642 17.6221L1.74028 17.6867C0.856822 15.9942 0.355713 14.0578 0.355713 11.9999C0.355713 10.0101 0.824238 8.13356 1.65473 6.48127H1.65537L4.28716 6.97964L5.44005 9.6817C5.19875 10.4083 5.06724 11.1883 5.06724 11.9999C5.06733 12.8808 5.22181 13.7248 5.50522 14.5034Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3885 9.75821C23.522 10.4841 23.5915 11.2338 23.5915 12C23.5915 12.8591 23.5041 13.6971 23.3375 14.5055C22.7719 17.2562 21.2942 19.6582 19.247 21.358L19.2464 21.3573L15.9315 21.1826L15.4623 18.1575C16.8207 17.3347 17.8823 16.047 18.4415 14.5055H12.2291V9.75821H18.5321H23.3885Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.246 21.3574L19.2467 21.358C17.2557 23.011 14.7266 24 11.9734 24C7.54908 24 3.70245 21.4457 1.74017 17.6868L5.50512 14.5036C6.48623 17.2081 9.01216 19.1334 11.9734 19.1334C13.2463 19.1334 14.4387 18.778 15.462 18.1576L19.246 21.3574Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3892 2.76262L15.6255 5.94524C14.5665 5.26152 13.3147 4.86656 11.9736 4.86656C8.94528 4.86656 6.37212 6.88016 5.44015 9.68174L1.65542 6.4813H1.65479C3.58833 2.63076 7.48348 0 11.9736 0C14.7925 0 17.3771 1.03715 19.3892 2.76262Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2357,
    height: 24,
    fill: "white",
    transform: "translate(0.355713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0795c65e.svg";
export { ForwardRef as ReactComponent };